<template>
  <tab-layout :actionBar="true">
    <secretary-add-details :memberDetails="memberDetails" :edit="edit" slot="tabContent" class="tab-pane row mx-0 show active" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import secretaryAddDetails from './SecretaryAddDetails'

export default {
  name: 'SecretaryAdd',
  props: ['memberDetails', 'edit'],
  components: {
    'tab-layout': tabLayout,
    'secretary-add-details': secretaryAddDetails
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Add/SecretaryAdd.vue